import * as React from "react";
import type { TypePeekInTriggerProps } from "../PeekInTypes";

/**
 * Marks the element that opens the PeekIn.
 *
 * This is a slot marker, not a renderer. PeekIn reads `children` off this
 * element and wires it up itself — as the Modal's trigger on desktop, and as a
 * click-handled clone on mobile — so this component is never mounted on either
 * path. It renders its children only as a defensive fallback for direct use.
 */
export const PeekInTrigger: React.FC<TypePeekInTriggerProps> = ({
  children,
}) => <>{children}</>;

PeekInTrigger.displayName = "PeekInTrigger";
